import { defineWebExtension } from '@databink/web/extension';
import { MonthlyRevenue, PartySubscriptions } from './billing.js';
import { LeadDemos } from './demos.js';

/**
 * Databink's screen extensions, compiled into its build of the web app
 * (DATABINK_CLIENT=databink). The slots filled here are the ones src/index.ts declares, which
 * `databink client verify` checks against the core's registry; test/web.test.ts keeps the
 * two lists in step. brand/ holds the Databink icon and logo for light and dark pages, which
 * the sign-in page, the menu and the browser tab show.
 */
export default defineWebExtension({
  client: 'databink',
  brand: {
    icon: new URL('./brand/databink-icon-light.svg', import.meta.url).href,
    logo: new URL('./brand/databink-logo-light.svg', import.meta.url).href,
    iconDark: new URL('./brand/databink-icon-dark.svg', import.meta.url).href,
    logoDark: new URL('./brand/databink-logo-dark.svg', import.meta.url).href,
    // The icon again, turning white in a dark browser's tab bar.
    favicon: new URL('./brand/databink-favicon.svg', import.meta.url).href,
  },
  slots: {
    'app.dashboard': [
      { id: 'monthly-revenue', title: 'Monthly recurring revenue', component: MonthlyRevenue },
    ],
    'crm.party.detail.tabs': [
      { id: 'subscriptions', label: 'Subscriptions', component: PartySubscriptions },
    ],
    'crm.lead.detail.tabs': [{ id: 'demos', label: 'Demos', component: LeadDemos }],
  },
});
